<div class="newsletter">
  <div class="newsletter__imgcontainer">
    <img [src]="isMobile ? newsLetterLandingImageMobile : newsLetterLandingImage" />
  </div>
  <div class="newsletter__content">
    <p class="newsletter__content__header">
      {{ 'HOME.HOME_PAGE.NEWSLETTER-LANDING.HEADER' | translate }}
    </p>
    <p class="newsletter__content__subheader">
      {{ 'HOME.HOME_PAGE.NEWSLETTER-LANDING.SUBHEADER' | translate }}
    </p>
    <p class="newsletter__content__body">
      {{ 'HOME.HOME_PAGE.NEWSLETTER-LANDING.BODY' | translate }}
    </p>
    <div>
      <button mm-button class="newsletter__content__button" [color]="'primary'" (click)="onClick()">
        {{ 'HOME.HOME_PAGE.NEWSLETTER-LANDING.BUTTON' | translate }}
      </button>
    </div>
  </div>
</div>
